import { Stack } from '@mui/material'
import TextInputField from '../../fields/text-input-field/text-input-field.component'
import SuggestionAutocompleteField from '../../fields/suggestion-autocomplete-field/suggestion-autocomplete-field.component'
import { CITIZENSHIP_COUNTRIES } from '../../../pages/driver/data/citizenship-countries'

const UpdateDriverForm = () => {
  return (
    <Stack spacing={2}>
      <TextInputField name="firstName" label="First Name" />
      <TextInputField name="lastName" label="Last Name" />
      <TextInputField name="address" label="Address" />
      <TextInputField name="licenseNumber" label="Licence Number" />
      <TextInputField name="dateOfIssue" label="Date of Issue" type="date" />
      <TextInputField name="expiryDate" label="Expiry Date" type="date" />
      <TextInputField
        name="driverReferenceNumber"
        label="Driver Reference Number"
      />
      <TextInputField name="sex" label="Sex" />
      <TextInputField name="licenseClass" label="Licence Class" />
      <TextInputField name="restrictions" label="Restrictions/Conditions" />
      <TextInputField name="dateOfBirth" label="Date of Birth" type="date" />
      <TextInputField name="height" label="Height" />
      <TextInputField name="typeOfLicense" label="Type of License" />
      <SuggestionAutocompleteField
        name="citizenshipCountry"
        label="Citizenship Country"
        options={CITIZENSHIP_COUNTRIES}
      />
      <TextInputField name="fastCardNumber" label="FAST Card Number" />
    </Stack>
  )
}

export default UpdateDriverForm
